export default "__VITE_ASSET__5f7a7cf4__"